import { createSlice } from "@reduxjs/toolkit";

const subscriptionModalSlice = createSlice({
  name: "subsModal",
  initialState: {
    open: false,
  },
  reducers: {
    openSubscriptionModal: (state, { payload }) => {
      state.open = true;
    },
    closeSubscriptionModal: (state, { payload }) => {
      state.open = false;
    },
  },
});
export const { openSubscriptionModal, closeSubscriptionModal } =
  subscriptionModalSlice.actions;
export default subscriptionModalSlice.reducer;
